module.exports = __webpack_public_path__ + "img/龟甲.a5dcdb66.jpg";